<template>
  <div
    v-if="modelValue"
    class="skill_detail_pop"
    @click.self="closePopup"
    @touchmove.prevent
  >
    <div class="panel">
      <div class="close_btn" @click="closePopup">
        <img src="./images/close.png" alt="" />
      </div>
      <div class="panel_body" ref="panelBodyRef">
        <div class="panel_header">
          <div class="head_icon" v-if="item?.skillIcon">
            <img :src="item.skillIcon" alt="" />
          </div>
          <div class="head_title">{{ item?.skillName || "技能详情" }}</div>
        </div>

        <div class="desc_text">{{ item?.skillDesc || "暂无内容" }}</div>

        <div class="tag_list" v-if="item?.featureTags?.length">
          <span
            class="tag_item"
            v-for="(tag, index) in item.featureTags"
            :key="index"
            >{{ tag }}</span
          >
        </div>

        <div class="feature_title" v-if="item?.featurePoints?.length">
          功能特点
        </div>
        <div
          class="feature_item"
          v-for="(point, index) in item?.featurePoints || []"
          :key="`${point}-${index}`"
        >
          <span class="check_icon">
            <img src="./images/right.png" alt="" />
          </span>
          <span class="feature_text">{{ point }}</span>
        </div>
      </div>

      <div class="panel_footer">
        <div
          class="left_btn"
          style="width: 1.4rem"
          @click="emit('view-doc', item)"
          tracker-eventcode="dc-ckwd_000"
        >
          <div class="ic_btn"><img src="./images/ic_ckwd.png" alt="" /></div>
          <div class="btn_txt">查看文档</div>
        </div>
        <div
          class="left_btn"
          @click="emit('link-hub', item)"
          tracker-eventcode="dc-djclawhubzd_000"
        >
          <div class="ic_btn"><img src="./images/ic_zd.png" alt="" /></div>
          <div class="btn_txt">Claw Hub直达</div>
        </div>
        <div
          class="copy_btn"
          @click="copySkillDesc"
          tracker-eventcode="dc-djyjfzskill_000"
        >
          <div class="copy_icon">
            <img src="./images/ic_copy.png" alt="" />
          </div>
          一键复制Skill到OpenClaw
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import fetchData from "@/utils/fetchData";
import { $loading, $toast } from "@/utils/globalUtils";
import copyTextToClipboard from "@/utils/copy";
import { copyContent } from "@/utils/common";
import { ref, watch } from "vue";
const copyText = ref("");
const panelBodyRef = ref<HTMLElement | null>(null);
type SkillItem = {
  skillName: string;
  skillDesc: string;
  skillIcon: string;
  skillTag: string;
  featureTags: string[];
  featurePoints: string[];
};
const props = defineProps<{
  modelValue: boolean;
  item: SkillItem | null;
  hasAISQAuth: boolean;
}>();
const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
  (event: "view-doc", value: SkillItem | null): void;
  (event: "link-hub", value: SkillItem | null): void;
  (event: "copy", value: string): void;
  (event: "auth"): void;
}>();
const closePopup = () => {
  emit("update:modelValue", false);
};

const restorePanelScrollTop = (scrollTop: number) => {
  const panel = panelBodyRef.value;
  if (!panel) {
    return;
  }
  panel.scrollTop = scrollTop;
  requestAnimationFrame(() => {
    if (panelBodyRef.value) {
      panelBodyRef.value.scrollTop = scrollTop;
    }
  });
  setTimeout(() => {
    if (panelBodyRef.value) {
      panelBodyRef.value.scrollTop = scrollTop;
    }
  }, 50);
};

/** * 获取skill内容 */
const getSkillContent = (callback: any) => {
  let obj = {
    api: `/skill/content?st=${new Date().getTime()}`,
    data: { skillTag: props.item?.skillTag },
    success: (res: any) => {
      if (res && res.status == 0 && res.data) {
        copyText.value = res.data;
        callback && callback(res.data);
      } else {
        copyText.value = "";
        callback && callback("");
      }
    },
    fail: () => {
      callback && callback("");
    },
  };
  fetchData.doGet(obj);
};
watch(
  () => [props.modelValue, props.item?.skillTag],
  () => {
    if (props.modelValue && props.item?.skillTag) {
      getSkillContent(null);
    }
  },
  { immediate: true }
);

const copySkillDesc = async () => {
  if (!copyText.value) {
    $toast.show("当前skill已暂停止使用", 3000);
    return;
  }
  if (props.item?.skillTag == "aisq" && !props.hasAISQAuth) {
    // AI社区未授权
    emit("auth");
    return;
  }
  $loading.show();
  const text = copyText.value;
  const panelScrollTop = panelBodyRef.value?.scrollTop || 0;
  if (!text) {
    $loading.hide();
    return;
  }

  copyContent({
    content: text,
    callback: (isSuccess: any) => {
      if (isSuccess) {
        $loading.hide();
        $toast.show("复制成功", 3000);
      } else {
        $loading.hide();
        $toast.show("复制失败，请长按手动复制", 3000);
      }
      restorePanelScrollTop(panelScrollTop);
    },
  });
};
</script>
<style scoped lang="scss">
.skill_detail_pop {
  position: fixed;
  inset: 0;
  z-index: 999;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35);
  .panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 7.5rem;
    margin: 0 auto;
    max-height: calc(100% - 0.32rem);
    background: #ffffff;
    border-radius: 0.32rem 0.32rem 0 0;
    overflow: hidden;
    .close_btn {
      position: absolute;
      right: 0.24rem;
      top: 0.24rem;
      width: 0.48rem;
      height: 0.48rem;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .panel_body {
      flex: 1;
      overflow-y: auto;
      padding: 0.36rem 0.32rem 0.4rem;
      .panel_header {
        display: flex;
        align-items: center;
        padding-right: 0.6rem;
        .head_icon {
          width: 0.48rem;
          height: 0.48rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .head_title {
          margin-left: 0.16rem;
          font-size: 0.4rem;
          font-weight: 600;
          color: #333;
        }
      }
      .desc_text {
        margin-top: 0.22rem;
        font-size: 0.28rem;
        color: #666666;
        line-height: 0.44rem;
      }
      .tag_list {
        margin-top: 0.2rem;
        margin-bottom: 0.12rem;
        display: flex;
        flex-wrap: wrap;
        .tag_item {
          box-sizing: border-box;
          margin-right: 0.12rem;
          padding-left: 0.12rem;
          padding-right: 0.12rem;
          height: 0.44rem;
          line-height: 0.44rem;
          background: #f8f8fa;
          border-radius: 0.08rem;
          font-size: 0.24rem;
          color: #333;
        }
      }
      .feature_title {
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #333;
        font-weight: bold;
      }
      .feature_item {
        margin-top: 0.14rem;
        display: flex;
        align-items: center;
        .check_icon {
          width: 0.4rem;
          height: 0.4rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .feature_text {
          margin-left: 0.08rem;
          font-size: 0.28rem;
          color: #4a4a4a;
          line-height: 0.42rem;
        }
      }
    }
    .panel_footer {
      display: flex;
      align-items: center;
      width: 100%;
      height: 1.5rem;
      padding: 0;
      background: #ffffff;
      box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0.08);
      .left_btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1.7rem;
        font-size: 0;
        color: #333;
        .ic_btn {
          width: 0.44rem;
          height: 0.44rem;
          margin-top: 0.12rem;
          font-size: 0;
          img {
            width: 0.44rem;
            height: 0.44rem;
          }
        }
        .btn_txt {
          font-size: 0.24rem;
          transform: scale(0.916);
          transform-origin: center center;
        }
      }
      .copy_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4.24rem;
        height: 0.92rem;
        border-radius: 0.46rem;
        background: #ff5500;
        color: #fff;
        font-size: 0.26rem;
        font-weight: 500;
        .copy_icon {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.12rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
